import(/* webpackMode: "eager" */ "/app/src/app/(app-providers)/settings/page.tsx");
